<template>
  <!-- <div class="text-center">
    <img src="@/assets/img/logo.png" alt="">
  </div> -->

  <v-card class="mx-auto" shaped elevation="7" min-height="80vh">
    <v-card-text>
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12"></v-col>
            <div class="center-me">
              <img src="@/assets/img/logo.png" alt="" width="80%">
            </div>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
  export default {
    name: 'Home',
    mounted(){
            if(_.get(this.$root,'accessPla',false)){
                this.$router.push({path:'/formulario-lavado-activo/cliente/index'})
                      .catch(e => { console.info(e)})

            }
    }
  }
</script>
<style scoped>
  .center-me {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80vh;
  }
</style>